
  import { defineComponent, ref, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { IndicesType } from '@/store/enums/TypeOfIndicesEnums';
  import { MethodologyObject } from '@/store/modules/Indices/MethodologyModule';
  import { useAbility } from '@casl/vue';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';

  export default defineComponent({
    name: 'methodology-listing',
    components: {
      Datatable,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('methodologyListing'), [
          translate('indices'),
        ]);
      });

      const loading = ref(false);
      const priceIndexItems = ref<MethodologyObject[]>([]);
      const volumeIndexItems = ref<MethodologyObject[]>([]);

      const bySort = (items: MethodologyObject[]) =>
        [...items].sort((a, b) => a.sort - b.sort);

      const fetchSections = async () => {
        loading.value = true;
        const [priceRes, volumeRes] = await Promise.all([
          store.dispatch(Actions.GET_METHODOLOGIES, IndicesType.PRICE_INDEX.id),
          store.dispatch(
            Actions.GET_METHODOLOGIES,
            IndicesType.VOLUME_INDEX.id
          ),
        ]);
        priceIndexItems.value = bySort(priceRes.data.data);
        volumeIndexItems.value = bySort(volumeRes.data.data);
        loading.value = false;
      };

      await fetchSections();

      const tableHeader = ref([
        {
          name: translate('titleEn'),
          key: 'titleEn',
          sortable: true,
        },
        {
          name: translate('titleAr'),
          key: 'titleAr',
          sortable: true,
        },
        {
          name: translate('status'),
          key: 'isActive',
          sortable: true,
        },
        {
          name: translate('lastUpdated'),
          key: 'updatedAt',
          sortable: true,
        },
        {
          name: translate('actions'),
          key: 'actions',
        },
      ]);

      const formatDate = (dateString: string) => {
        if (!dateString) return '';
        return new Date(dateString).toLocaleDateString('en-GB');
      };

      const editItem = (id: number) => {
        router.push({ name: 'methodology-editing', params: { id } });
      };

      const priceDetailedKey = 'price_methodology_detailed';
      const volumeDetailedKey = 'volume_methodology_detailed';

      const editDetailed = (key: string) => {
        router.push({ name: 'methodology-detailed-editing', params: { key } });
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        translate,
        tableHeader,
        priceIndexItems,
        volumeIndexItems,
        formatDate,
        editItem,
        priceDetailedKey,
        volumeDetailedKey,
        editDetailed,
        loading,
        can,
      };
    },
  });
